import { Component, OnInit } from '@angular/core';
import { SkyKickPanelTabViewBase, populateContentWithPlaceholders} from '@skykick/core';
import NotificationDetailsViewModel from './models/notification-details-view-model';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { EventSeverityToIconClass, EventSeverityToIconName } from '../utils/event-severity.util';
import { replaceSkyKick } from '../utils/text-replace.util';

@Component({
  selector: 'sk-notification-details-panel',
  templateUrl: './notifications-details-panel.component.html'
})
export class NotificationDetailsPanelComponent extends SkyKickPanelTabViewBase<NotificationDetailsViewModel, void> implements OnInit {
  constructor(private readonly sanitizer: DomSanitizer) {
    super();
  }

  eventSeverityToIconClass = EventSeverityToIconClass;
  eventSeverityToIconName = EventSeverityToIconName;
  notification: NotificationDetailsViewModel;
  safeBodyHtml: SafeHtml;
  safeSubjectHtml: SafeHtml;

  ngOnInit(): void {
    this.notification = this.data;

    this.safeBodyHtml = this.sanitizer.bypassSecurityTrustHtml(
      replaceSkyKick(
        populateContentWithPlaceholders(this.notification.body),
        ''
      ));

    this.safeSubjectHtml = this.sanitizer.bypassSecurityTrustHtml(
      replaceSkyKick(
        populateContentWithPlaceholders(this.notification.subject),
        ''
      ));
  }
}
